<template>
  <div class='detail-body'>
    <div class='main-section'>
        <div>
            <label>Event Name</label>
            <input class='dark' type='text' placeholder="Event Name" v-model='inputFields.name' name='eventName' v-validate>
        </div>
        <div>
            <label>Start Date</label>
            <input class='dark' type='text' placeholder="Start Date" v-model='inputFields.start' name='eventStart' v-validate>
        </div>
        <div>
            <label>End Date</label>
            <input class='dark' type='text' placeholder="End Date" v-model='inputFields.end' name='eventEnd' v-validate>
        </div>
        <div class='details-section'>
            <label>Details</label>
            <div class='editor-body'>
                <quill-editor
                name='eventDescription'
                v-validate
                v-model="inputFields.details">
                </quill-editor>
            </div>
        </div>
    </div>
    <div class='right-section'>
        <label>Brand</label>
        <div class='brand-container'>
            <div>
                <label>Primary Color</label>
                <input type='text'/>
            </div>
            <div>
                <label>Secondary Color</label>
                <input type='text'/>
            </div>
            <div>
                <label>Font</label>
                <input type='text'/>
            </div>
            <div class='brand-preview'>
                <label style='display:block;'>Preview</label>
                <div class='brand-preview-body'>
                </div>
            </div>
        </div>
        <input class='dark' type='button' value='Save' @click='save()'/>
    </div>
  </div>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { DateTime } from "luxon";
import { mapFields } from "vee-validate";

import { quillEditor } from "vue-quill-editor";
export default {
  props: ["id"],
  data() {
    return {
      event: null,
      inputFields: {
        name: "",
        start: "",
        end: "",
        details: ""
      }
    };
  },
  computed: mapFields([
    "eventName",
    "eventStart",
    "eventEnd",
    "eventDescription"
  ]),

  methods: {
    save: function() {
      var update = {};
      if (this.eventName.dirty) {
        update.name = this.inputFields.name;
      }
      if (this.eventStart.dirty) {
        update.start = this.inputFields.start;
      }
      if (this.eventEnd.dirty) {
        update.end = this.inputFields.end;
      }
      if (this.eventDescription.dirty) {
        update.details = this.inputFields.description;
      }
      if (Object.keys(update).length === 0) return;
      this.$store.dispatch("events/update", {
        id: this.id,
        update: update
      });
    },
    getEvent: function() {
      return this.$store
        .dispatch("events/get", { id: this.id })
        .then(() => this.$store.getters["events/event"](this.id))
        .then(event => (this.event = event));
    }
  },
  watch: {
    event: {
      deep: true,
      handler: function(v) {
        this.inputFields.name = v.name;
        this.inputFields.start = v.start;
        this.inputFields.end = v.end;
        this.inputFields.details = v.details;
      }
    }
  },
  beforeMount: function() {
    this.getEvent();
  },

  components: {
    quillEditor
  }
};
</script>

<style scoped lang='scss'>
.editor-body {
  background: $gray-1;
  color: black;
  flex-grow: 1;
}
.detail-body {
  color: $primary;
  display: flex;
  flex-direction: row;
  flex-grow: 1;
}
.main-section {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}
.details-section {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}
.right-section {
  width: 550px;
  display: flex;
  flex-direction: column;
  margin-left: 32px;
}
.brand-container {
  border: 1px solid $primary;
  padding: 12px;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}
.brand-preview {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}
.brand-preview-body {
  border: 1px solid $primary;
  flex-grow: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/event/details.vue